import { Injectable } from '@angular/core';

/**
 * Serviço para armazenar uma mensagem pendente que deve ser exibida
 * após o próximo redirecionamento de rota.
 * Utilizado pelo guard quando nega acesso a uma área e redireciona para outra.
 */
@Injectable({ providedIn: 'root' })
export class PendingMessageService {
  private _message: string | null = null;

  set(message: string): void {
    this._message = message;
  }

  consume(): string | null {
    const msg = this._message;
    this._message = null;
    return msg;
  }
}
